import { useContext, useEffect, useRef } from "react";
import { MultiSymbolMarginContext } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/MultiSymbolMargin.context";

export const useSearchInput = () => {
  const {
    searchValue,
    setSearchValue,
    isSearchOpen,
    setIsSearchOpen,
    filteredSymbols,
  } = useContext(MultiSymbolMarginContext)!;
  const searchInputRef = useRef<any>(undefined);

  useEffect(() => {
    if (isSearchOpen) searchInputRef.current?.focus();
  }, [isSearchOpen]);

  const closeSearch = () => {
    setIsSearchOpen(false);
    setSearchValue("");
  };

  return {
    isSearchOpen,
    value: searchValue,
    onOpenSearchClick: () => setIsSearchOpen(true),
    onCloseSearch: closeSearch,
    onChange: (value?: string) => setSearchValue(value),
    searchInputRef,
    hide: !filteredSymbols.length,
  };
};
